import {useEffect} from "react";
import Head from 'next/head'
import supportsWebP from 'supports-webp';
import AOS from "aos";
import {useRouter} from "next/router";

export default function MainLayout(
    {
        children,
        title,
        alternate,
        description,
        keywords,
        page,
        loaded,
        schemaData,
        organizationSchemaData,
        canonical
    }) {

    const router = useRouter();

    const getBaseUrl = () => {
        return process.env.NEXT_PUBLIC_SITE_URL || 'https://pepedollar.io'
    }

    useEffect(() => {

        supportsWebP.then(supported => {
            if (supported) {
                document.body.classList.add('webp')
            }
        });
    }, [])

    useEffect(() => {
        if (loaded) {
            AOS.init({
                once: true
            });
        }
    }, [loaded])

    return (
        <>
            <Head>
                <title>{title}</title>
                <link rel="icon" href={`/img/icons/favicon.png`}/>
                <link rel="apple-touch-icon" sizes="180x180" href={`/img/icons/apple-touch-icon.png`}/>
                <link rel="icon" type="image/png" sizes="32x32" href={`/img/icons/favicon-32x32.png`}/>
                <link rel="icon" type="image/png" sizes="16x16" href={`/img/icons/favicon-16x16.png`}/>
                <link rel="mask-icon" href={`/img/icons/safari-pinned-tab.svg" color="#fc5a57`}/>
                <meta name="msapplication-TileColor" content="#da532c"/>
                <meta name="theme-color" content="#ffffff"/>
                <meta name="description" content={description}/>
                <meta name="keywords" content={keywords}/>

                <link rel="canonical"
                      href={canonical && router.locale === 'en' ? getBaseUrl() + canonical : canonical && router.locale !== 'en'? getBaseUrl() + '/' + router.locale + canonical : router.locale === 'en' ? getBaseUrl() : getBaseUrl() + '/' + router.locale}/>
                <link rel="alternate" hreflang="en"
                      href={alternate ? `${getBaseUrl()}/${alternate}` : `${getBaseUrl()}`}/>
                <link rel="alternate" hreflang="ar"
                      href={alternate ? `${getBaseUrl()}/ar/${alternate}` : `${getBaseUrl()}/ar`}/>
                <link rel="alternate" hreflang="bn"
                      href={alternate ? `${getBaseUrl()}/bn/${alternate}` : `${getBaseUrl()}/bn`}/>
                <link rel="alternate" hreflang="de"
                      href={alternate ? `${getBaseUrl()}/de/${alternate}` : `${getBaseUrl()}/de`}/>
                <link rel="alternate" hreflang="es"
                      href={alternate ? `${getBaseUrl()}/es/${alternate}` : `${getBaseUrl()}/es`}/>
                <link rel="alternate" hreflang="fr"
                      href={alternate ? `${getBaseUrl()}/fr/${alternate}` : `${getBaseUrl()}/fr`}/>
                <link rel="alternate" hreflang="hi"
                      href={alternate ? `${getBaseUrl()}/hi/${alternate}` : `${getBaseUrl()}/hi`}/>
                <link rel="alternate" hreflang="id"
                      href={alternate ? `${getBaseUrl()}/id/${alternate}` : `${getBaseUrl()}/id`}/>
                <link rel="alternate" hreflang="it"
                      href={alternate ? `${getBaseUrl()}/it/${alternate}` : `${getBaseUrl()}/it`}/>
                <link rel="alternate" hreflang="ja"
                      href={alternate ? `${getBaseUrl()}/ja/${alternate}` : `${getBaseUrl()}/ja`}/>
                <link rel="alternate" hreflang="ko"
                      href={alternate ? `${getBaseUrl()}/ko/${alternate}` : `${getBaseUrl()}/ko`}/>
                <link rel="alternate" hreflang="pt"
                      href={alternate ? `${getBaseUrl()}/pt/${alternate}` : `${getBaseUrl()}/pt`}/>
                <link rel="alternate" hreflang="ru"
                      href={alternate ? `${getBaseUrl()}/ru/${alternate}` : `${getBaseUrl()}/ru`}/>
                <link rel="alternate" hreflang="tr"
                      href={alternate ? `${getBaseUrl()}/tr/${alternate}` : `${getBaseUrl()}/tr`}/>
                <link rel="alternate" hreflang="zh"
                      href={alternate ? `${getBaseUrl()}/zh/${alternate}` : `${getBaseUrl()}/zh`}/>
                <link rel="alternate" hreflang="x-default"
                      href={alternate ? `${getBaseUrl()}/${alternate}` : `${getBaseUrl()}`}/>

                <meta property="og:url" content={getBaseUrl()}/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content={title}/>
                <meta property="og:description" content={description}/>
                <meta property="og:image" content={`${getBaseUrl()}/img/main/og.png`}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content={getBaseUrl()}/>
                <meta property="twitter:url" content={getBaseUrl()}/>
                <meta name="twitter:title" content=''/>
                <meta name="twitter:description" content=''/>
                <meta name="twitter:image" content={`${getBaseUrl()}/img/main/og.png`}/>
                {schemaData &&
                    <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(schemaData)}}/>}
                {organizationSchemaData && <script type="application/ld+json"
                                                   dangerouslySetInnerHTML={{__html: JSON.stringify(organizationSchemaData)}}/>}
            </Head>
            <div className={page}>
                {children}
            </div>
        </>
    )
}